$(function() {
	$(".input-slider" ).each(function(i){
		//console.log(this);
		if(!$(this).hasClass('input-slider-init'))
		{
			$(this).addClass('input-slider-init');

			var slideDown = function(event)
			{
				var $slider = $(event.target).parents('.slider-control-group').eq(0).find('.input-slider-wrapper');
				var $field = $(event.target).parents('.slider-control-group').eq(0).find('.input-slider-init');
				var value = $slider.slider('value');
				var step = $slider.slider('option').step;
				$slider.slider('value',value - step)
				$field.val($slider.slider('value'));
			}

			var slideUp = function(event)
			{
				var $slider = $(event.target).parents('.slider-control-group').eq(0).find('.input-slider-wrapper');
				var $field = $(event.target).parents('.slider-control-group').eq(0).find('.input-slider-init');
				var value = $slider.slider('value');
				var step = $slider.slider('option').step;
				$slider.slider('value',value + step)
				$field.val($slider.slider('value'));
			}

			// append wrapper node for the slider component
			var inputGroup = $('<div class="slider-control-group o-'+$(this).data('sliderOrientation')+'"><div class="input-group"></div></div>');
			$(this).wrap(inputGroup);

			if($(this).data('sliderPrepend'))
			{
				var extra = $('<div class="input-group-addon">'+$(this).data('sliderPrepend')+'</div>');
				extra.on('click',slideDown);
				$(this).before(extra);
			}

			if($(this).data('sliderUnite'))
				$(this).after('<div class="input-group-addon">'+$(this).data('sliderUnite')+'</div>');

			if($(this).data('sliderAppend'))
			{
				var extra = $('<div class="input-group-addon">'+$(this).data('sliderAppend')+'</div>');
				extra.on('click',slideUp);
				$(this).after(extra);
			}

			var sliderWrapper = $('<div class="input-slider-wrapper" id="input_slider_'+i+'"></div>');
			$(this).parent().before(sliderWrapper);

			// then link new node with original form field
			$(sliderWrapper).data('sliderField',this);

			// init the slider component
			$(sliderWrapper).slider({
				range: "min",
				value: $(this).data('sliderValue'),
				step: $(this).data('sliderStep'),
				orientation: $(this).data('sliderOrientation'),
				min: $(this).data('sliderMin'),
				max: $(this).data('sliderMax'),
				slide: function( event, ui ) {
					var field = $($(this).data('sliderField'));
					var _default = field.data('sliderDefault');
					if(1*_default!=0 || ui.value > 0 || ui.value < 0)
					{
						field.val(1*ui.value);
					}
					else
					{
						field.val(_default);
					}
				}
			});
			

			// finally fill form field value with the original value
			var originalValue = 1*$(this).data('sliderValue');
			if(1*$(this).data('sliderDefault')==0 && originalValue==0)
				originalValue = $(this).data('sliderDefault');
			$(this).val(originalValue);
		}
	})
});